import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import Layout from "../components/layouts/Layout";

type Props = {
  children: React.ReactNode;
  redirectLink?: string;
  title?: string;
  headline?: string;
};

function ProtectedRouteOrganizer({ children, redirectLink, title = "Organizer", headline = "" }: Props) {
  const { accessToken, role } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  const currentPath = encodeURIComponent(location.pathname + location.search);

  if (role === "ORGANIZER" && accessToken) {
    return (
      <Layout title={title} headline={headline}>
        {children}
      </Layout>
    );
  }
  // If another user is logged in → redirect to their dashboard
  if (role === "ADMIN") return <Navigate to="/admin" replace />;
  if (role === "STORE") return <Navigate to="/store/dashboard" replace />;
  if (role === "OWNER") return <Navigate to="/owner" replace />;

  return (
    <Navigate
      to={redirectLink ? redirectLink : `/organizer/send-otp?redirect=${currentPath}`}
      replace
    />
  );
}

export default ProtectedRouteOrganizer;
